import {
  Typography,
  type TypographyProps,
} from '@jouzen/ecom-components/v3/Typography';

import Motion from '@/app/components/Motion';

export interface CareersTextAnimationProps {
  /** text to animate over the start text */
  readonly endText: string;
  /** initial text to display */
  readonly startText: string;
}

const CareersTextAnimation = ({
  endText,
  startText,
}: CareersTextAnimationProps) => {
  const typographyProps: Omit<TypographyProps, 'children'> = {
    Element: 'h2',
    height: 'tight',
    variant: 'h1',
    weight: 'light',
  };

  return (
    <div className="relative w-[94px] overflow-hidden md:w-[140px] lg:w-[190px]">
      <Typography {...typographyProps}>{startText}</Typography>
      <Motion
        animate={{ x: 0 }}
        className="absolute top-0 left-0 w-full [--x-from:-90px] md:[--x-from:-136px] lg:[--x-from:-186px]"
        initial={{ x: 'var(--x-from, -90px)' }}
        transition={{ delay: 2, duration: 1, ease: [0.4, 0, 0.2, 1] }}
      >
        <Typography
          className="w-full border-r-4 border-solid border-blue-200 bg-sandstone-400"
          {...typographyProps}
        >
          {endText}
        </Typography>
      </Motion>
    </div>
  );
};

export default CareersTextAnimation;
